import { AnalyticsBrowser } from '@segment/analytics-next';

let analytics: AnalyticsBrowser | null = null;

export const initializeSegmentAnalytics = () => {
  if (window.config.segmentAnalyticsEnabled === '0') {
    // console.log('Segment Analytics is disabled');
    return null;
  }

  if (!window.config.segmentCdnUrl || !window.config.segmentWriteKey) {
    // console.warn('Segment Analytics configuration missing in window.config');
    return null;
  }

  if (analytics) {
    // console.log('Segment Analytics already initialized');
    return analytics;
  }

  try {
    analytics = AnalyticsBrowser.load({
      cdnURL: window.config.segmentCdnUrl,
      writeKey: window.config.segmentWriteKey,
    });

    // console.log('Segment Analytics initialized successfully');

    return analytics;
  } catch (error) {
    // console.error('Failed to initialize Segment Analytics:', error);
    return null;
  }
};

export const getSegmentAnalytics = () => {
  return analytics;
};

// // Initialize analytics when the module is loaded (if enabled)
// if (typeof window !== 'undefined') {
//   initializeSegmentAnalytics();
// }
